__turbopack_context__.v({
  "accordionItem": "OnboardingProcess-module__P1AnNG__accordionItem",
  "accordionMobile": "OnboardingProcess-module__P1AnNG__accordionMobile",
  "accordionPanel": "OnboardingProcess-module__P1AnNG__accordionPanel",
  "accordionSummary": "OnboardingProcess-module__P1AnNG__accordionSummary",
  "activities": "OnboardingProcess-module__P1AnNG__activities",
  "centralLine": "OnboardingProcess-module__P1AnNG__centralLine",
  "connector": "OnboardingProcess-module__P1AnNG__connector",
  "container": "OnboardingProcess-module__P1AnNG__container",
  "ctaBanner": "OnboardingProcess-module__P1AnNG__ctaBanner",
  "ctaButton": "OnboardingProcess-module__P1AnNG__ctaButton",
  "ctaInner": "OnboardingProcess-module__P1AnNG__ctaInner",
  "ctaText": "OnboardingProcess-module__P1AnNG__ctaText",
  "heading": "OnboardingProcess-module__P1AnNG__heading",
  "iconCircle": "OnboardingProcess-module__P1AnNG__iconCircle",
  "iconRow": "OnboardingProcess-module__P1AnNG__iconRow",
  "intro": "OnboardingProcess-module__P1AnNG__intro",
  "left": "OnboardingProcess-module__P1AnNG__left",
  "outcome": "OnboardingProcess-module__P1AnNG__outcome",
  "right": "OnboardingProcess-module__P1AnNG__right",
  "step": "OnboardingProcess-module__P1AnNG__step",
  "stepInner": "OnboardingProcess-module__P1AnNG__stepInner",
  "stepNumber": "OnboardingProcess-module__P1AnNG__stepNumber",
  "timeline": "OnboardingProcess-module__P1AnNG__timeline",
  "timelineDesktop": "OnboardingProcess-module__P1AnNG__timelineDesktop",
  "timelineStep": "OnboardingProcess-module__P1AnNG__timelineStep",
  "title": "OnboardingProcess-module__P1AnNG__title",
  "wrapper": "OnboardingProcess-module__P1AnNG__wrapper",
});
